import Loader from '../../components/shared/loader';
import { AccountsContext } from '../../components/context/account-context';
import { getAllDashboardFleet } from '../../services/dashboard-service';
import { getDateRangeUTC } from '../../utils/set-date-range-utils';
import React, { useContext, useEffect, useState } from 'react';
import Heading from '../../components/shared/heading';
import DataBoxes from './components/upper-boxes';
import Help from './help';
import { usePageHelp } from '../../components/context/help-context';

const Home = () => {
    usePageHelp(Help);
    const { accountId, attributes } = useContext(AccountsContext);
    const [dateRange, setDateRange] = useState({
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
    });
    const [fleetData, setFleetData] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const { from, to } = getDateRangeUTC(dateRange);

            const [fleetResponse] = await Promise.all([
                getAllDashboardFleet(accountId, from),
            ]);

            if (fleetResponse.success) {
                setFleetData(fleetResponse.data.data || {});
                setError(null);
            } else {
                setError(fleetResponse.data?.message || 'Failed to fetch dashboard fleet records');
            }
        } catch (err) {
            console.error('Error fetching dashboard data:', err);
            setError('An error occurred while fetching dashboard data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (accountId && dateRange) {
            fetchDashboardData();
        }
    }, [accountId, dateRange]);

    return (
        <div className="relative p-4">
            <Heading>Dashboard</Heading>
            {error && (
                <div className="text-red-600 bg-red-100 px-4 py-2 rounded-md">
                    {error}
                </div>
            )}
            {loading && <Loader />}
            <div className='my-4'>
                <DataBoxes data={fleetData} attributes={attributes} />
            </div>
        </div>
    );
};

export default Home;
